export default __webpack_public_path__ + "static/partner4-45209dcb1ed754532ea4d23b360c61a6.jpg";